<template>
    <div class="metric">
        <div @mouseenter="hover=true" @mouseleave="hover=false" class="d-flex align-center">
            <span class="header" :id="name" v-html="name"  />
            <router-link :to="{hash: name}" v-if="hover">¶</router-link>
        </div>
        <v-row class="field" no-gutters>
            <v-col cols="12" sm="2" class="name">
                description
            </v-col>
            <v-col cols="12" sm="10" class="value">
                <slot name="description"></slot>
            </v-col>
        </v-row>
        <v-row class="field" no-gutters>
            <v-col cols="12" sm="2" class="name">
                source
            </v-col>
            <v-col cols="12" sm="10" class="value">
                <slot name="source"></slot>
            </v-col>
        </v-row>
        <v-row class="field" no-gutters>
            <v-col cols="12" sm="2" class="name">
                type
            </v-col>
            <v-col cols="12" sm="10" class="value">
                <var>{{type}}</var>
            </v-col>
        </v-row>
        <v-row class="field" no-gutters>
            <v-col cols="12" sm="2" class="name">
                labels
            </v-col>
            <v-col cols="12" sm="10" class="value">
                <slot name="labels"></slot>
            </v-col>
        </v-row>
        <v-row v-if="$slots.used" class="field" no-gutters>
            <v-col cols="12" sm="2" class="name">
                usages
            </v-col>
            <v-col cols="12" sm="10" class="value">
                <slot name="used"></slot>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    props: {
        name: String,
        type: String,
    },
    data() {
        return {
            hover: false
        }
    }
};

</script>

<style scoped>

.metric {
    margin: 36px 0;
}

.metric .header {
    padding: 4px;
    font-size: 18px;
    font-weight: 500;
    /*margin-top: 32px;*/
    max-width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;

}

.metric .field {
    /*flex-wrap: nowrap;*/
    border-bottom: 1px solid rgba(0,0,0,0.12);
    align-items: center;
}
.metric .field:last-of-type {
    border-bottom: none;
}

.metric .field .name {
    color: rgba(0,0,0,0.5);
    font-weight: 500;
    padding: 4px;
    font-size: 12px;
    text-transform: uppercase;
}

.metric .field .value {
    padding: 4px;
    font-size: 14px;
    flex-grow: 2;
}
</style>
